/**
 * Molecule Assessment — shared UI primitives (Figma 813:9340)
 * Exposed as window.WmAssessmentUI
 */
(function (global) {
  'use strict';

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

var ARROW_LEFT =
  '<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
  '<rect width="28" height="28" rx="14" fill="#219C87"/>' +
  '<path d="M12.4056 18.4756C12.2809 18.4756 12.1563 18.4297 12.0578 18.3312L8.07438 14.3478C7.88406 14.1575 7.88406 13.8425 8.07438 13.6522L12.0578 9.66874C12.2481 9.47842 12.5631 9.47842 12.7534 9.66874C12.9438 9.85905 12.9438 10.174 12.7534 10.3644L9.11781 14L12.7534 17.6356C12.9438 17.8259 12.9438 18.1409 12.7534 18.3312C12.6616 18.4297 12.5303 18.4756 12.4056 18.4756Z" fill="#F1F8FE"/>' +
  '<path d="M19.5779 14.4922H8.5332C8.26414 14.4922 8.04102 14.2691 8.04102 14C8.04102 13.7309 8.26414 13.5078 8.5332 13.5078H19.5779C19.847 13.5078 20.0701 13.7309 20.0701 14C20.0701 14.2691 19.847 14.4922 19.5779 14.4922Z" fill="#F1F8FE"/>' +
  '</svg>';

  var INFO_ICON =
    '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">' +
    '<circle cx="8" cy="8" r="6.25" stroke="currentColor" stroke-width="1.2"/>' +
    '<path d="M8 7.2v3.2M8 5.2h.01" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>' +
    '</svg>';

  function progress(pct) {
    var n = Math.max(0, Math.min(100, Math.round(Number(pct) || 0)));
    return (
      '<div class="wma__progress" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' +
      n +
      '" aria-label="Assessment progress">' +
      '<p class="wma__progress-pct">' +
      n +
      '%</p>' +
      '<div class="wma__progress-track">' +
      '<div class="wma__progress-fill' +
      (n > 0 ? ' is-active' : '') +
      '" style="width:' +
      n +
      '%"></div></div>' +
      '</div>'
    );
  }

  function backButton() {
    return (
      '<button type="button" class="wma__back" data-action="back">' +
      ARROW_LEFT +
      '<span>Back</span></button>'
    );
  }

  function primaryButton(label, action, opts) {
    opts = opts || {};
    var cls = 'wma__btn';
    if (opts.disabled) cls += ' is-disabled';
    if (opts.loading) cls += ' is-loading';
    if (opts.extraClass) cls += ' ' + opts.extraClass;
    var icon = opts.showArrow
      ? '<span class="wma__btn-icon" aria-hidden="true">' +
        '<svg width="20" height="20" viewBox="0 0 24 24" fill="none">' +
        '<path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>' +
        '</svg></span>'
      : '';
    return (
      '<button type="button" class="' +
      cls +
      '"' +
      (action ? ' data-action="' + esc(action) + '"' : '') +
      (opts.disabled ? ' disabled aria-disabled="true"' : '') +
      '>' +
      '<span>' +
      esc(label || 'Continue') +
      '</span>' +
      icon +
      '</button>'
    );
  }

  function secondaryButton(label, action, opts) {
    opts = opts || {};
    var cls = opts.cream ? 'wma__btn wma__btn--cream' : 'wma__btn wma__btn--secondary';
    return (
      '<button type="button" class="' +
      cls +
      '" data-action="' +
      esc(action || '') +
      '"' +
      (opts.uploadKey ? ' data-upload-key="' + esc(opts.uploadKey) + '"' : '') +
      '>' +
      esc(label) +
      '</button>'
    );
  }

  function tertiaryButton(label, action, opts) {
    opts = opts || {};
    var cls = 'wma__btn wma__btn--tertiary';
    if (opts.linkStyle) cls += ' wma__btn--link';
    return (
      '<button type="button" class="' +
      cls +
      '" data-action="' +
      esc(action || '') +
      '"' +
      (opts.guidelines ? ' data-guidelines="' + esc(opts.guidelines) + '"' : '') +
      '>' +
      esc(label) +
      '</button>'
    );
  }

  function heading(text) {
    return '<h1 class="wma__heading">' + esc(text) + '</h1>';
  }

  function hint(text) {
    return text ? '<p class="wma__hint">' + esc(text) + '</p>' : '';
  }

  function hintGp(text) {
    return text ? '<p class="wma__hint wma__hint--gp">' + esc(text) + '</p>' : '';
  }

  function alert(message, type) {
    if (!message) return '';
    return (
      '<p class="wma__alert wma__alert--' +
      esc(type || 'error') +
      '" role="alert">' +
      esc(message) +
      '</p>'
    );
  }

  function rejectScreen(page) {
    page = page || {};
    var bodyHtml = String(page.body || '')
      .split(/\n+/)
      .map(function (p) {
        return esc(p.trim());
      })
      .filter(Boolean)
      .join('<br>');
    return (
      '<div class="wma__reject" role="status">' +
      '<div class="wma__reject-icon" aria-hidden="true">' +
      '<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<circle cx="24" cy="24" r="21" stroke="#C0392B" stroke-width="3" fill="none"/>' +
      '<line x1="10" y1="10" x2="38" y2="38" stroke="#C0392B" stroke-width="3" stroke-linecap="round"/>' +
      '</svg></div>' +
      '<h1 class="wma__heading wma__reject-heading">' +
      esc(page.heading || '') +
      '</h1>' +
      (bodyHtml ? '<p class="wma__reject-body">' + bodyHtml + '</p>' : '') +
      primaryButton(page.nextLabel || 'Go back to Home', 'go-home', { showArrow: true }) +
      '</div>'
    );
  }

  function noticeScreen(page) {
    page = page || {};
    var action = page.nextAction || 'next';
    return (
      '<div class="wma__notice">' +
      '<div class="wma__notice__copy">' +
      '<h1 class="wma__heading">' +
      esc(page.heading || '') +
      '</h1>' +
      '<p class="wma__notice__body">' +
      esc(page.body || '') +
      '</p></div>' +
      primaryButton(page.nextLabel || 'Continue', action, {
        showArrow: !!page.showArrow
      }) +
      '</div>'
    );
  }

  function infoRow(text) {
    return (
      '<div class="wma__info-row">' + INFO_ICON + '<span>' + esc(text) + '</span></div>'
    );
  }

  /**
   * Figma height/weight ruler picker (445:8028 / 445:8069).
   * opts: { field, value, unit, secondary, min, max, step, nudge, labels }
   */
  function rulerPicker(opts) {
    opts = opts || {};
    var value = Number(opts.value) || 0;
    var min = Number(opts.min) || 0;
    var max = Number(opts.max) || 100;
    var step = Number(opts.step) || 1;
    var unit = esc(opts.unit || '');
    var field = esc(opts.field || '');
    var intPart = String(Math.round(value));
    var html =
      '<div class="wma__ruler-picker" data-ruler-root="' +
      field +
      '">' +
      '<div class="wma__ruler-readout">' +
      '<p class="wma__ruler-secondary" data-ruler-secondary>' +
      (opts.secondaryHtml || esc(opts.secondary || '')) +
      '</p>' +
      '<div class="wma__ruler-card">' +
      '<p class="wma__ruler-primary" data-ruler-primary>' +
      '<span data-ruler-value>' +
      esc(intPart) +
      '</span><span class="wma__ruler-unit">' +
      unit +
      '</span></p></div></div>' +
      '<div class="wma__ruler" data-ruler="' +
      field +
      '">' +
      '<div class="wma__ruler-center" aria-hidden="true"></div>' +
      '<div class="wma__ruler-viewport">' +
      '<div class="wma__ruler-track" data-ruler-track></div></div>' +
      '<input class="wma__ruler-input" type="range" min="' +
      min +
      '" max="' +
      max +
      '" step="' +
      step +
      '" value="' +
      value +
      '" data-field="' +
      field +
      '" aria-label="' +
      esc(opts.ariaLabel || field) +
      '">' +
      '<div class="wma__ruler-labels" data-ruler-labels aria-hidden="true"></div></div>';
    if (opts.nudge) {
      html +=
        '<div class="wma__info-row wma__info-row--nudge' +
        (opts.nudgeHidden ? ' is-hidden' : '') +
        '"' +
        (opts.nudgeHidden ? ' hidden' : '') +
        ' data-ruler-nudge>' +
        INFO_ICON +
        '<span data-ruler-nudge-text>' +
        esc(opts.nudge) +
        '</span></div>';
    }
    html += '</div>';
    return html;
  }

  /**
   * Single / multi option cards.
   * @param {object} q - question config
   * @param {string|string[]} value - current answer
   * @param {boolean} multi
   */
  function optionCards(q, value, multi) {
    var selected = multi
      ? Array.isArray(value)
        ? value
        : []
      : value
        ? [value]
        : [];
    var name = esc(q.field || q.id);
    var type = multi ? 'checkbox' : 'radio';
    var labelId = 'wma-legend-' + name;
    // Use a div title (not <legend>) — legend + width:100% can cover inputs and block typing.
    var html =
      '<fieldset class="wma__fieldset" aria-labelledby="' +
      labelId +
      '">' +
      '<div id="' +
      labelId +
      '" class="wma__legend">' +
      esc(q.heading) +
      '</div>';
    if (q.hint) html += hint(q.hint);
    html += '<div class="wma__options" role="group">';
    (q.options || []).forEach(function (opt) {
      var isOn = selected.indexOf(opt.value) !== -1;
      html +=
        '<label class="wma__option' +
        (isOn ? ' is-selected' : '') +
        '" data-option-field="' +
        name +
        '" data-option-value="' +
        esc(opt.value) +
        '"' +
        (multi ? ' data-option-multi="1"' : '') +
        '>' +
        '<input type="' +
        type +
        '" name="' +
        name +
        '" value="' +
        esc(opt.value) +
        '"' +
        (isOn ? ' checked' : '') +
        ' data-field="' +
        name +
        '"' +
        (multi ? ' data-multi="1"' : '') +
        ' tabindex="-1">' +
        esc(opt.label) +
        '</label>';
      // Figma: detail field sits directly under the triggering option (e.g. Yes → input → No)
      var otherTriggers = Array.isArray(q.otherValues)
        ? q.otherValues
        : q.otherValue
          ? [q.otherValue]
          : [];
      if (otherTriggers.indexOf(opt.value) !== -1 && isOn) {
        if (q.otherTextarea) {
          html +=
            '<span class="wma__input-shell wma__input-shell--textarea">' +
            '<textarea class="wma__input-pill wma__input-pill--textarea" data-other="' +
            name +
            '" placeholder="' +
            esc(q.otherPlaceholder || 'Please specify') +
            '" aria-label="' +
            esc(q.otherPlaceholder || 'Please specify') +
            '" rows="4">' +
            esc(q._otherValue || '') +
            '</textarea></span>';
        } else {
          html +=
            '<span class="wma__input-shell">' +
            '<input class="wma__input-pill" type="text" data-other="' +
            name +
            '" placeholder="' +
            esc(q.otherPlaceholder || 'Please specify') +
            '" value="' +
            esc(q._otherValue || '') +
            '" aria-label="' +
            esc(q.otherPlaceholder || 'Please specify') +
            '"></span>';
        }
      }
    });
    html += '</div>';
    html += '</fieldset>';
    return html;
  }

  function textField(opts) {
    opts = opts || {};
    var labelHtml = '';
    if (opts.fieldLabel) {
      labelHtml =
        '<span class="wma__field-label">' +
        esc(opts.fieldLabel) +
        (opts.required ? ' <span class="wma__req" aria-hidden="true">*</span>' : '') +
        '</span>';
    } else if (opts.label) {
      labelHtml = '<span class="wma__legend">' + esc(opts.label) + '</span>';
    }
    return (
      '<label class="wma__fieldset' +
      (opts.className ? ' ' + esc(opts.className) : '') +
      '">' +
      labelHtml +
      '<span class="wma__input-shell">' +
      '<input class="wma__input-pill' +
      (opts.invalid ? ' is-invalid' : '') +
      '" type="' +
      esc(opts.type || 'text') +
      '" data-field="' +
      esc(opts.id) +
      '" placeholder="' +
      esc(opts.placeholder || '') +
      '" value="' +
      esc(opts.value || '') +
      '"' +
      (opts.autocomplete ? ' autocomplete="' + esc(opts.autocomplete) + '"' : '') +
      (opts.inputmode ? ' inputmode="' + esc(opts.inputmode) + '"' : '') +
      (opts.required ? ' required aria-required="true"' : '') +
      ' aria-label="' +
      esc(opts.ariaLabel || opts.fieldLabel || opts.label || opts.placeholder || opts.id) +
      '">' +
      '</span></label>'
    );
  }

  function detailsFields(answers) {
    answers = answers || {};
    return (
      '<div class="wma__details">' +
      '<div class="wma__details-row">' +
      textField({
        id: 'first_name',
        fieldLabel: 'First Name',
        placeholder: 'First Name',
        value: answers.first_name || '',
        autocomplete: 'given-name',
        required: true,
        className: 'wma__fieldset--half'
      }) +
      textField({
        id: 'last_name',
        fieldLabel: 'Last Name',
        placeholder: 'Last Name',
        value: answers.last_name || '',
        autocomplete: 'family-name',
        required: true,
        className: 'wma__fieldset--half'
      }) +
      '</div>' +
      textField({
        id: 'phone',
        type: 'tel',
        fieldLabel: 'Phone Number',
        placeholder: 'Phone Number',
        value: answers.phone || '',
        autocomplete: 'tel',
        inputmode: 'tel',
        required: true
      }) +
      textField({
        id: 'email',
        type: 'email',
        fieldLabel: 'Email Address',
        placeholder: 'Email Address',
        value: answers.email || '',
        autocomplete: 'email',
        required: true
      }) +
      '</div>'
    );
  }

  /* Figma 2636:47671 — GP practice fields + NHS suggestion dropdown */
  function gpDetailsFields(answers) {
    answers = answers || {};
    return (
      '<div class="wma__details wma__gp-details">' +
      '<div class="wma__gp-surgery-wrap">' +
      textField({
        id: 'gp_name',
        fieldLabel: 'GP Practice Name:',
        placeholder: 'e.g. The Woodgate Surgery',
        value: answers.gp_name || '',
        autocomplete: 'off',
        required: true
      }) +
      '<div class="wma__gp-suggestions" data-gp-suggestions hidden></div>' +
      '</div>' +
      textField({
        id: 'gp_address',
        fieldLabel: 'GP Practice Address (Street address, city/town):',
        placeholder: 'e.g. 134 Main st',
        value: answers.gp_address || '',
        autocomplete: 'street-address',
        required: true
      }) +
      textField({
        id: 'gp_postcode',
        fieldLabel: 'Postcode:',
        placeholder: 'e.g. L80SQ',
        value: answers.gp_postcode || '',
        autocomplete: 'postal-code',
        required: true
      }) +
      '</div>'
    );
  }

  function dobFields(answers, opts) {
    answers = answers || {};
    opts = opts || {};
    var invalidCls = opts.invalid ? ' is-invalid' : '';
    return (
      '<fieldset class="wma__fieldset" aria-labelledby="wma-legend-dob">' +
      '<div id="wma-legend-dob" class="wma__legend">What is your date of birth?</div>' +
      '<div class="wma__dob-row">' +
      '<span class="wma__input-shell wma__input-shell--grow">' +
      '<input class="wma__input-pill' +
      invalidCls +
      '" type="text" inputmode="numeric" maxlength="2" data-field="dob_dd" placeholder="DD" value="' +
      esc(answers.dob_dd || '') +
      '" aria-label="Day" autocomplete="bday-day"></span>' +
      '<span class="wma__input-shell wma__input-shell--grow">' +
      '<input class="wma__input-pill' +
      invalidCls +
      '" type="text" inputmode="numeric" maxlength="2" data-field="dob_mm" placeholder="MM" value="' +
      esc(answers.dob_mm || '') +
      '" aria-label="Month" autocomplete="bday-month"></span>' +
      '<span class="wma__input-shell wma__input-shell--grow">' +
      '<input class="wma__input-pill' +
      invalidCls +
      '" type="text" inputmode="numeric" maxlength="4" data-field="dob_yyyy" placeholder="YYYY" value="' +
      esc(answers.dob_yyyy || '') +
      '" aria-label="Year" autocomplete="bday-year"></span>' +
      '</div></fieldset>'
    );
  }

  function confirmToggle(id, checked, label, opts) {
    opts = opts || {};
    if (opts.accent) {
      return (
        '<label class="wma__confirm wma__confirm--accent' +
        (checked ? ' is-checked' : '') +
        '">' +
        '<input type="checkbox" id="wma-' +
        esc(id) +
        '" data-field="' +
        esc(id) +
        '"' +
        (checked ? ' checked' : '') +
        '>' +
        '<span class="wma__confirm-box" aria-hidden="true"></span>' +
        '<span class="wma__confirm-text">' +
        esc(label) +
        '</span></label>'
      );
    }
    return (
      '<div class="wma__confirm">' +
      '<input type="checkbox" id="wma-' +
      esc(id) +
      '" data-field="' +
      esc(id) +
      '"' +
      (checked ? ' checked' : '') +
      '>' +
      '<label for="wma-' +
      esc(id) +
      '">' +
      esc(label) +
      '</label></div>'
    );
  }

  function infoAckBody(page) {
    page = page || {};
    var html = '<div class="wma__info-ack">';
    (page.bodyParagraphs || []).forEach(function (p) {
      html += '<p class="wma__info-ack__p">' + esc(p) + '</p>';
    });
    if (page.bodyList && page.bodyList.length) {
      html += '<ul class="wma__info-ack__list">';
      page.bodyList.forEach(function (item) {
        html += '<li>' + esc(item) + '</li>';
      });
      html += '</ul>';
    }
    html += '</div>';
    return html;
  }

  var CAL_MONTHS = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ];

  var CAL_ARROW_LEFT =
    '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
    '<path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';

  var CAL_ARROW_RIGHT =
    '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
    '<path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';

  function pad2(n) {
    return (n < 10 ? '0' : '') + n;
  }

  /** Figma calendar (445:7556). year/month 0-based month. selectedIso: YYYY-MM-DD */
  function calendarGrid(year, month, selectedIso) {
    var firstDay = new Date(year, month, 1).getDay();
    var daysInMonth = new Date(year, month + 1, 0).getDate();
    var daysInPrev = new Date(year, month, 0).getDate();
    var html =
      '<div class="wma__cal">' +
      '<div class="wma__cal-header">' +
      '<button type="button" class="wma__cal-arrow" data-action="cal-prev" aria-label="Previous month">' +
      CAL_ARROW_LEFT +
      '</button>' +
      '<p class="wma__cal-title">' +
      esc(CAL_MONTHS[month] + ' ' + year) +
      '</p>' +
      '<button type="button" class="wma__cal-arrow" data-action="cal-next" aria-label="Next month">' +
      CAL_ARROW_RIGHT +
      '</button></div>' +
      '<div class="wma__cal-weekdays" aria-hidden="true">';
    ['S', 'M', 'T', 'W', 'T', 'F', 'S'].forEach(function (d) {
      html += '<span>' + d + '</span>';
    });
    html += '</div><div class="wma__cal-grid" role="grid">';
    for (var p = firstDay - 1; p >= 0; p--) {
      html +=
        '<span class="wma__cal-day is-outside" aria-hidden="true">' +
        (daysInPrev - p) +
        '</span>';
    }
    for (var i = 1; i <= daysInMonth; i++) {
      var iso = year + '-' + pad2(month + 1) + '-' + pad2(i);
      var sel = iso === selectedIso ? ' is-selected' : '';
      html +=
        '<button type="button" class="wma__cal-day is-current' +
        sel +
        '" data-action="cal-select" data-date="' +
        esc(iso) +
        '" aria-label="' +
        esc(iso) +
        '"' +
        (sel ? ' aria-pressed="true"' : ' aria-pressed="false"') +
        '>' +
        i +
        '</button>';
    }
    var totalCells = firstDay + daysInMonth;
    var trailing = totalCells % 7 === 0 ? 0 : 7 - (totalCells % 7);
    for (var t = 1; t <= trailing; t++) {
      html +=
        '<span class="wma__cal-day is-outside" aria-hidden="true">' + t + '</span>';
    }
    html += '</div></div>';
    return html;
  }

  function calendarPicker(opts) {
    opts = opts || {};
    var selected = opts.selected || '';
    var now = new Date();
    var viewYear = opts.viewYear != null ? opts.viewYear : now.getFullYear();
    var viewMonth = opts.viewMonth != null ? opts.viewMonth : now.getMonth();
    if (selected) {
      var sp = String(selected).split('-');
      if (sp.length === 3 && opts.viewYear == null) {
        viewYear = parseInt(sp[0], 10);
        viewMonth = parseInt(sp[1], 10) - 1;
      }
    }
    return (
      '<div class="wma__calendar-wrap" data-calendar data-field="' +
      esc(opts.field || 'last_dose_date') +
      '" data-view-year="' +
      viewYear +
      '" data-view-month="' +
      viewMonth +
      '" data-selected="' +
      esc(selected) +
      '">' +
      calendarGrid(viewYear, viewMonth, selected) +
      '</div>'
    );
  }

  function assessmentIcon(name, fallbackPath) {
    var root = document.getElementById('wm-assessment-app');
    var fromData = root && root.getAttribute('data-icon-' + name);
    var src = fromData || fallbackPath || '';
    if (!src) return '';
    return (
      '<img class="wma__icon-img" src="' +
      esc(src) +
      '" alt="" width="24" height="24" decoding="async">'
    );
  }

  function uploadZone(opts) {
    opts = opts || {};
    var variant = opts.variant || 'default';
    var key = esc(opts.uploadKey || '');
    var inputId = 'wma-file-' + key;
    var input =
      '<input type="file" class="wma__sr-file" id="' +
      inputId +
      '" data-upload-input data-upload-key="' +
      key +
      '" accept="image/png,image/jpeg,image/gif,application/pdf,.png,.jpg,.jpeg,.gif,.pdf">';
    var previewUrl = opts.previewUrl || '';
    var showPreview = variant === 'proof' && previewUrl && !opts.isPdf;

    if (variant === 'proof') {
      var inner = showPreview
        ? '<span class="wma__upload-zone__preview">' +
          '<img src="' +
          esc(previewUrl) +
          '" alt="' +
          esc(opts.previewAlt || 'Uploaded image preview') +
          '">' +
          '</span>'
        : '<span class="wma__upload-icon" aria-hidden="true">' +
          assessmentIcon('export', '/assets/wma-icon-export.svg') +
          '</span>' +
          '<span class="wma__upload-zone__copy">' +
          '<span class="wma__upload-zone__title">' +
          esc(opts.label || 'Click to upload Image') +
          '</span>' +
          '<span class="wma__upload-zone__hint">' +
          esc(opts.hint || 'PNG,JPG, PDF or GIF (max, 3MB)') +
          '</span></span>';

      return (
        input +
        '<label for="' +
        inputId +
        '" class="wma__upload-zone wma__upload-zone--proof' +
        (showPreview ? ' has-preview' : '') +
        '">' +
        inner +
        '</label>'
      );
    }
    return (
      input +
      '<label for="' +
      inputId +
      '" class="wma__upload-zone">' +
      '<span>' +
      esc(opts.label || 'Tap to upload or take a photo') +
      '</span><span>' +
      esc(opts.hint || 'PNG, JPG or PDF · max 3MB') +
      '</span></label>'
    );
  }

  function uploadFileRow(opts) {
    opts = opts || {};
    var key = esc(opts.uploadKey || '');
    var pct = Math.max(0, Math.min(100, Math.round(Number(opts.progress) || 0)));
    var done = pct >= 100 && !opts.uploading;
    var tick = done
      ? assessmentIcon('tick-circle', '/assets/wma-icon-tick-circle.svg')
      : '<span class="wma__upload-file__tick-placeholder" aria-hidden="true"></span>';
    return (
      '<div class="wma__upload-file" data-upload-row="' +
      key +
      '">' +
      '<div class="wma__upload-file__main">' +
      '<span class="wma__upload-file__tick" aria-hidden="true">' +
      tick +
      '</span>' +
      '<div class="wma__upload-file__meta">' +
      '<div class="wma__upload-file__row">' +
      '<span class="wma__upload-file__name">' +
      esc(opts.name || 'File') +
      '</span>' +
      '<span class="wma__upload-file__pct" data-upload-progress="' +
      key +
      '">' +
      pct +
      '%</span></div>' +
      '<div class="wma__upload-file__bar" aria-hidden="true">' +
      '<div class="wma__upload-file__bar-fill' +
      (pct > 0 ? ' is-complete' : '') +
      '" data-upload-bar="' +
      key +
      '" style="width:' +
      pct +
      '%"></div></div></div></div>' +
      '<button type="button" class="wma__upload-file__remove" data-action="clear-upload" data-upload-key="' +
      key +
      '" aria-label="Remove file">' +
      assessmentIcon('close-x', '/assets/wma-icon-close-x.svg') +
      '</button></div>'
    );
  }

  function photoExampleCard(rootEl, attr, caption) {
    var src = (rootEl && rootEl.getAttribute(attr)) || '';
    return (
      '<div class="wma__photo-example">' +
      '<div class="wma__photo-example__frame">' +
      (src
        ? '<img src="' + esc(src) + '" alt="' + esc(caption) + '" width="162" height="208">'
        : '<span class="wma__photo-example__placeholder" aria-hidden="true"></span>') +
      '</div>' +
      '<p class="wma__photo-example__caption">' +
      esc(caption) +
      '</p></div>'
    );
  }

  function photoExamples(rootEl) {
    return (
      '<div class="wma__photo-examples">' +
      '<div class="wma__photo-examples__row">' +
      photoExampleCard(
        rootEl,
        'data-guideline-fb-do',
        'Do: Full Body. Tight fitted clothing. Front mage.'
      ) +
      photoExampleCard(
        rootEl,
        'data-guideline-fb-dont-baggy',
        "Don't: Wear dark or baggy clothes that hide your body shape"
      ) +
      '</div><div class="wma__photo-examples__row">' +
      photoExampleCard(
        rootEl,
        'data-guideline-fb-dont-face',
        "Don't: Close up of your face. No body shown."
      ) +
      photoExampleCard(
        rootEl,
        'data-guideline-fb-dont-body',
        "Don't: Show only your body without your face showing"
      ) +
      '</div></div>'
    );
  }

  function idDocExamples(rootEl, docType) {
    var isPassport = docType === 'passport';
    var html = '<div class="wma__id-examples' + (isPassport ? ' wma__id-examples--passport' : '') + '">';
    if (isPassport) {
      var passSrc = (rootEl && rootEl.getAttribute('data-guideline-id-passport')) || '';
      html +=
        '<div class="wma__id-example">' +
        (passSrc
          ? '<img src="' + esc(passSrc) + '" alt="Passport example" width="167" height="111">'
          : '<span class="wma__id-example__placeholder" aria-hidden="true"></span>') +
        '</div>';
      html +=
        '<p class="wma__id-examples__hint">Please take a clear photo of front of your passport photo page</p>';
    } else {
      var front = (rootEl && rootEl.getAttribute('data-guideline-id-dl-front')) || '';
      var back = (rootEl && rootEl.getAttribute('data-guideline-id-dl-back')) || '';
      html +=
        '<div class="wma__id-examples__row">' +
        '<div class="wma__id-example">' +
        (front
          ? '<img src="' + esc(front) + '" alt="Driving licence front" width="163" height="112">'
          : '<span class="wma__id-example__placeholder" aria-hidden="true"></span>') +
        '</div>' +
        '<div class="wma__id-example">' +
        (back
          ? '<img src="' + esc(back) + '" alt="Driving licence back" width="163" height="112">'
          : '<span class="wma__id-example__placeholder" aria-hidden="true"></span>') +
        '</div></div>';
      html +=
        '<p class="wma__id-examples__hint">Please take clear photos of both the front and back of your driving license. Make sure we can see your photo, name and date of birth clearly.</p>';
    }
    html += '</div>';
    return html;
  }

  function photoPreviewBox(opts) {
    opts = opts || {};
    var src = opts.src || '';
    var camera = !!opts.camera;
    var cls = 'wma__photo-preview';
    if (camera) cls += ' has-camera';
    else if (src) cls += ' has-image';
    var inner = '';
    if (camera) {
      inner =
        '<video class="wma__photo-preview__video" data-camera-preview playsinline autoplay muted></video>';
    } else if (src) {
      inner =
        '<img src="' + esc(src) + '" alt="' + esc(opts.alt || 'Uploaded photo') + '">';
    }
    return '<div class="' + cls + '">' + inner + '</div>';
  }

  function shell(opts) {
    opts = opts || {};
    var pct = opts.progress != null ? opts.progress : 0;
    var html =
      '<div class="wma__shell' + (opts.hideChrome ? ' wma__shell--bare' : '') + '">';
    if (!opts.hideChrome) {
      html += progress(pct);
      if (opts.showBack) html += backButton();
    }
    html +=
      '<div class="wma__content' + (opts.animate ? ' wma__slide-enter' : '') + '">';
    html += opts.body || '';
    html += '</div></div>';
    return html;
  }

  global.WmAssessmentUI = {
    esc: esc,
    progress: progress,
    backButton: backButton,
    primaryButton: primaryButton,
    secondaryButton: secondaryButton,
    tertiaryButton: tertiaryButton,
    heading: heading,
    hint: hint,
    hintGp: hintGp,
    alert: alert,
    rejectScreen: rejectScreen,
    noticeScreen: noticeScreen,
    infoRow: infoRow,
    rulerPicker: rulerPicker,
    optionCards: optionCards,
    textField: textField,
    detailsFields: detailsFields,
    gpDetailsFields: gpDetailsFields,
    dobFields: dobFields,
    confirmToggle: confirmToggle,
    infoAckBody: infoAckBody,
    calendarPicker: calendarPicker,
    calendarGrid: calendarGrid,
    uploadZone: uploadZone,
    uploadFileRow: uploadFileRow,
    photoExamples: photoExamples,
    idDocExamples: idDocExamples,
    photoPreviewBox: photoPreviewBox,
    shell: shell,
    INFO_ICON: INFO_ICON
  };
})(window);
